/**
 * Служебный префикс ключа вложения: `attachment_<uuid>_`. Загрузка кладёт файл
 * как `attachment_{id}_{имя}.{ext}`, чтобы одноимённые файлы не затирали друг
 * друга в бакете, — но человеку этот идентификатор ничего не говорит и, стоя
 * первым, съедает всю видимую часть подписи: у двух соседних кадров совпадает
 * ровно то, что видно, а различается обрезанный хвост.
 */
const ATTACHMENT_KEY_PREFIX = /^attachment_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/i;

/**
 * Имя файла из s3-ключа: последний сегмент пути без служебного префикса
 * загрузки, а на вырожденном ключе («без слэшей» или с хвостовым слэшем) — сам
 * ключ. Нужен там, где вложение собирается из уже загруженного объекта (пикеры,
 * повтор запроса, блок файлов под сообщением) и настоящего `File.name` под
 * рукой нет.
 */
export function fileNameFromKey(s3Key: string): string {
    const tail = s3Key.split("/").pop();
    const name = tail && tail.length > 0 ? tail : s3Key;
    const withoutPrefix = name.replace(ATTACHMENT_KEY_PREFIX, "");
    // Ключ может состоять из одного префикса (имя файла пустое) — тогда лучше
    // показать его целиком, чем пустую подпись.
    return withoutPrefix.length > 0 ? withoutPrefix : name;
}
